/* Stack Builder PDP promo - moved to a theme asset (Claude, 26 Aug 2026).
   The inline <script> copy in the section is being neutralised for some
   visitors (guest sessions rendered dead grids on all three stores), while
   same-origin asset scripts run fine site-wide. This file restores the
   builder; it is GUARDED to no-op when the inline copy already executed,
   so nothing runs twice. Loaded with defer from sections/cro-stack-promo.liquid. */
var __csbCard = document.getElementById('csp-inline-card');
if (__csbCard && __csbCard.hidden) {
  (function(){
    var card = document.getElementById('csp-inline-card');
    var actions = document.querySelector('.pv2-form__actions');
    if (card && actions && actions.parentNode) {
      actions.parentNode.insertBefore(card, actions);
      card.hidden = false;
    }
    /* What's Included sits under the ATC button on chain PDPs (Danny 26 Aug) */
    var wi = document.querySelector('.pv2-form__actions .cro-wi');
    var bc = document.querySelector('.pv2-form__actions .pv2-form__button-container');
    if (wi && bc) {
      bc.insertAdjacentElement('afterend', wi);
      wi.style.marginTop = '14px';
    }
  })();
}
